const rawApiBaseUrl = import.meta.env.VITE_QL_API_BASE_URL;

if (!rawApiBaseUrl) {
  throw new Error('Missing VITE_QL_API_BASE_URL');
}

export const API_BASE_URL = rawApiBaseUrl.replace(/\/$/, '');

export const NETWORK_ERROR_MESSAGE = '网络请求失败';
export const SIGN_KEY = 'qlaihb';
export const DEFAULT_TIMEOUT = 10000;
